<button *ngIf="active" (click)="openChat()" class="chatbot-fixed" [class.chatbot-fixed--hide]="hide" title="Chat">
    <svg class="svg-icon svg-icon--m"><use href="assets/icons-general.svg#chat"></use></svg>
    <span class="screen-reader-only">Chat</span>
</button>
